import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { selectSprayEventsArray } from 'services/sprayEvents/selectors';
import { DayOfTheWeekOptionsType } from 'components/DayOfTheWeekOptions/types';
import { WorksheetType } from 'services/worksheet/types';
import { selectFertilizerEventsArray } from 'services/fertilizerEvents/selectors';
import {
    WORKSHEET_TYPE_FERTILIZER,
    WORKSHEET_TYPE_WEED_SPRAY
} from 'services/worksheet/constants';
import { OwnProps } from './index';

const selectOptions = (
    state: AppState,
    props: OwnProps
): DayOfTheWeekOptionsType => props.options;

const selectWorksheetType = (state: AppState, props: OwnProps): WorksheetType =>
    props.worksheetType;

const selectFilteredDayOfTheWeekOptions = createDeepEqualSelector(
    selectOptions,
    selectSprayEventsArray,
    selectFertilizerEventsArray,
    selectWorksheetType,
    (options, sprayEventsArray, fertilizerEventsArray, worksheetType) => {
        switch (worksheetType) {
            case WORKSHEET_TYPE_FERTILIZER:
                return options.filter((option) =>
                    fertilizerEventsArray.some(
                        (event) => event.startDate === option.value
                    )
                );

            case WORKSHEET_TYPE_WEED_SPRAY:
                return options.filter((option) =>
                    sprayEventsArray
                        .filter((event) => event.sprayEvent.isWeedSpray)
                        .some((event) => event.startDate === option.value)
                );

            default:
                return options.filter((option) =>
                    sprayEventsArray
                        .filter((event) => !event.sprayEvent.isWeedSpray)
                        .some((event) => event.startDate === option.value)
                );
        }
    }
);

const makeSelectFilteredDayOfTheWeekOptions =
    (): typeof selectFilteredDayOfTheWeekOptions =>
        selectFilteredDayOfTheWeekOptions;

export {
    selectOptions,
    selectFilteredDayOfTheWeekOptions,
    makeSelectFilteredDayOfTheWeekOptions
};
